import SlimSelect from 'slim-select';
import AjaxForm from './ajax-form';
import ClipBoard from './clipboard';
export default class Modal {
	constructor() {

		this.modalBtns = document.querySelectorAll('[data-modal-open]');
		this.modal = document.querySelector('[data-modal]');
		this.modalBg = document.querySelector('.modal-backdrop');
		this.modalCloseBtn = document.querySelector('[data-modal-close]');

		this.select = '';

		this.modalBtns.forEach(modalBtn =>
			modalBtn.addEventListener('click', e => {
				this.handleClick(e.target);
			}),
		);

		this.modal.addEventListener('click', e => {
			if (e.target !== this.modal) {
				return;
			} else {
				this.closeModal(e);
			}
		});

		this.modalCloseBtn.addEventListener('click', e => {
			this.closeModal(e);
		});
	}

	handleClick(target){
		this.openModalWithUrl(target.dataset.url);
	}

	openModalWithContent(content){
		this.modal.querySelector('[data-modalcontent]').innerHTML = content;
		this.blessModal();
	}

	openModal(){
		this.checkScrollbar();
		this.setScrollbar();

		this.modal.classList.add('show');
		this.modalBg.classList.add('show');

		document.addEventListener('keydown', e => {
			if (e.key === 'Escape' || e.key === 'Esc') {
				this.closeModal(e);
			}
		});
	}

	openModalWithElement(elm, callback, style){

        const actualModal = this.modal.querySelector('.modal');
        for(let name of Object.keys(style)){
            actualModal.style[name] = style[name];
            console.log(`set ${name} to ${style[name]}`);
        }

		this.callback = callback;

		this.openModal();
		this.modal.querySelector('[data-modalcontent]').appendChild(elm);

		this.blessModal();
	}

	openModalWithUrl(url) {
		//misschien niet nodig, maar fallback voor refactor
		if(typeof url == 'undefined'){
			url = this.url;
		}
		fetch(url)
			.then(response => response.text())
			.then(data => {
				this.openModalWithContent(data);
			});

		this.openModal();

	}

	closeModal(e) {
		this.modal.classList.remove('show');
		this.modalBg.classList.remove('show');
		this.resetScrollbar();
		this.modal.querySelector('[data-modalcontent]').innerHTML = '';
		if (this.select) {
			this.select.destroy();
		}

        const actualModal = this.modal.querySelector('.modal');
        actualModal.removeAttribute('style');

		if(this.callback){
			try {
				console.log("Executing callback");
				this.callback();
			} catch(e){
				console.error(e);
			} finally {
				this.callback = null;
			}
		}else{
			console.debug("No callback for modal");
		}
	}

	checkScrollbar() {
		const rect = document.body.getBoundingClientRect();
		this.isBodyOverflowing = Math.round(rect.left + rect.right) < window.innerWidth;
		this.scrollbarWidth = this.getScrollbarWidth();
	}

	getScrollbarWidth() {
		const scrollDiv = document.createElement('div');
		scrollDiv.className = 'modal-scrollbar-measure';
		document.body.appendChild(scrollDiv);
		const scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
		document.body.removeChild(scrollDiv);

		return scrollbarWidth;
	}

	setScrollbar() {
		if (this.isBodyOverflowing) {
			document.body.style.paddingRight = Number.parseFloat(this.scrollbarWidth) + 'px';
		}
		document.body.classList.add('modal-open');
	}

	resetScrollbar() {
		document.body.style.paddingRight = '';
		document.body.classList.remove('modal-open');
	}

	blessModal() {

		new ClipBoard(this.modal);

		if (document.querySelector('[data-modal-select]')) {
			this.select = new SlimSelect({
				select: '[data-modal-select]',
				showSearch: false,
			});
		}

		if (document.querySelector('[data-ajax-form]')) {
			new AjaxForm(this.modal.querySelector('[data-ajax-form]'));
		}

		this.modal.querySelectorAll('[data-modal-close]').forEach(closeBtn =>
			closeBtn.addEventListener('click', e => {
				this.closeModal(e);
			}),
		);
		if (this.modal.querySelector('[data-modal-open]')) {
			this.modal.querySelector('[data-modal-open]').addEventListener('click', e => {
				this.handleClick(e.target);
			});
		}
	}
}
